import { useState } from "react";
import { Button } from "./Button";
import styles from "./Stippet.module.css";

export function Stippet({ title = "", body = "" }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const bodyWords = body.split(" ");
  const needsTruncation = bodyWords.length > 40;
  const truncatedText = needsTruncation
    ? `${bodyWords.slice(0, 40).join(" ")}...`
    : body;

  const handleExpandedToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <article className={styles.stippet}>
      <header className={styles.stippetHeader}>
        <h3>{title}</h3>
        {needsTruncation && (
          <Button onClick={handleExpandedToggle} variant="ghost" size="small">
            {isExpanded ? "Collapse" : "Read more"}
          </Button>
        )}
      </header>
      <p className={styles.stippetBody}>{isExpanded ? body : truncatedText}</p>
      {needsTruncation && !isExpanded && (
        <div className={styles.stippetFade} aria-hidden="true"></div>
      )}
    </article>
  );
}
